/*
  RecordCraft（工艺参数记录）by李小萱 2021/5/28
*/
<template>
    <div class="RecordCraft mainWrap" v-loading.fullscreen.lock="fullscreenLoading">
        <el-container style="height:100%; background-color:rgba(0, 0, 0, 0);" >
            <!-- 左边导航栏 -->
            <el-aside style="width:auto;">
                <leftNav msg="/RecordCraft"></leftNav>
            </el-aside>
            <!-- 右侧主体部分 -->
            <el-container>
                <el-main>
                    <div class="mainWrao">
                        <div class="recordTitle">
                            <h1>{{$t('leftNav.navTwentySeven')}}</h1>
                            <div class="chooseButton">
                                <div style="display:flex">
                                    <!-- 筛选设备 -->
                                    <el-popover
                                        v-loading="loading4"
                                        v-model="visible1"
                                        placement="bottom-start"
                                        width="500"
                                        @after-leave="hideMachine()"
                                        trigger="click"
                                        ref="popover1">
                                        <div class="noMachine" v-if="machineList.length==0">{{$t('EquipmentEfficiency.error5')}}</div>
                                        <div v-else>
                                            <ul class="machineList">
                                                <li v-for="(item1,index) in machineList" :class="{'active':isActiveMachine(item1)}" :key="index" @click="selectmachineId(item1)"  :title="item1.label">{{item1.label}}</li>
                                            </ul>
                                            <div style="text-align: right; margin: 0">
                                                <el-button type="primary" size="mini" @click="clickmachine">{{$t('EquipmentEfficiency.button1')}}</el-button>
                                            </div> 
                                        </div>
                                        <el-button type="primary" slot="reference">{{$t('EquipmentEfficiency.chooseEquipment')}}</el-button>                                 
                                    </el-popover>
                                    <!-- 筛选配方 -->
                                    <div v-loading="loading" style="margin-left:15px;">
                                        <el-popover
                                            v-model="visible2"
                                            placement="bottom-start"
                                            width="300"
                                            @after-leave="hideRecipe"
                                            popper-class="recipePopper"
                                            trigger="click"
                                            ref="popover2">
                                            <div class="noMachine" v-if="noRecord==1">{{$t('EquipmentEfficiency.error3')}}</div>
                                            <div class="noMachine" v-else-if="noRecord==2">{{$t('EquipmentEfficiency.error4')}}</div>
                                            <div v-else>
                                                <el-scrollbar class="machineWrap" style="height:85%;width:100%;">
                                                    <ul class="machineList recipeList">
                                                        <li @click="selectRecipeId(allRecipe)" :class="{'active':selectRecipe[0].value==''}" style="text-align:center;">{{$t('PartsFaultAlarm.all')}}</li>
                                                        <!-- <li v-for="(item,index) in recipeList" :class="{'active':selectRecipe.includes(item)}" :key="item.value" @click="selectRecipeId(item)"  :title="item.label">{{item.label}}</li> -->
                                                        <li v-for="item2 in recipeList" :class="{'active':isActiveRecipe(item2)}" :key="item2.value" @click="selectRecipeId(item2)"  :title="item2.label">{{item2.label}}</li>
                                                    </ul>
                                                </el-scrollbar>
                                                <div style="text-align: right; margin-top: 8px;">
                                                    <el-button type="primary" size="mini" @click="clickrecipe">{{$t('EquipmentEfficiency.button1')}}</el-button>
                                                </div>
                                            </div>
                                            <el-button type="primary" slot="reference" @click="checkRecipeBtn">{{$t('CompareCraft.chooseRecipe')}}</el-button>
                                        </el-popover>
                                    </div>
                                    <!-- 筛选调整人 -->
                                    <div v-loading="loading2" style="margin-left:15px;">
                                        <el-popover
                                            v-model="visible3"
                                            placement="bottom-start"
                                            width="500"
                                            @after-leave="hidePeople"
                                         
                                            trigger="click"
                                            ref="popover3">
                                            <div class="noMachine" v-if="nopeople==1">{{$t('EquipmentEfficiency.error6')}}</div>
                                            <div v-else>
                                                
                                                <ul class="machineList">
                                                    <li @click="clickPeople(allPeople)" :class="{'active':selectPeople[0].value==''}" style="text-align:center;">{{$t('PartsFaultAlarm.all')}}</li>
                                                    
                                                    <li v-for="item3 in peopleList" :class="{'active':selectPeople.includes(item3)}" :key="item3" @click="clickPeople(item3)"  :title="item3">{{item3}}</li>
                                                </ul>
                                               
                                                <div style="text-align: right; margin-top: 8px;">
                                                    <el-button type="primary" size="mini" @click="confirmPeople">{{$t('EquipmentEfficiency.button1')}}</el-button>
                                                </div>
                                            </div>
                                            <el-button type="primary" slot="reference">{{$t('EquipmentEfficiency.chooseReviser')}}</el-button>
                                        </el-popover>
                                    </div>
                                    <!-- 筛选调整项 -->
                                    <div v-loading="loading3" style="margin-left:15px;" :class="{itemWrap:showTags}">
                                        <el-cascader
                                            :key="iscascaderShow"
                                            @change="stagedFun"
                                            :show-all-levels="false"
                                            v-model="tagsVal"
                                            :placeholder="$t('EquipmentEfficiency.chooseItem')"
                                            :options="options"
                                            :props="props"
                                            @visible-change='stagedFun'
                                         
                                            collapse-tags
                                            >
                                        </el-cascader>
                                    </div>
                                </div>
                                <el-date-picker
                                    class="dateSelect"
                                    v-model="datePicker"
                                    type="daterange"
                                    :editable="editable"
                                    @change="changeTime"
                                    format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd"
                                    range-separator="~"
                                    :start-placeholder="$t('MachineDashBoard.StartTime')"
                                    :end-placeholder="$t('MachineDashBoard.EndTime')"
                                    align="left"
                                    >
                                </el-date-picker>
                                <div>
                                    <el-button type="primary" icon="el-icon-view" @click="getTableInfoByLook()">{{$t('StepCycleTime.showBtn')}}</el-button>
                                    <el-button
                                        icon="el-icon-download"
                                        class="export"
                                        style="margin-left:30px;"
                                        @click="exportExcel()"
                                    >
                                        {{ $t("ReloadingStatistics.export") }}
                                    </el-button>
                                </div>
                            </div>
                        </div>
                        <div class="tableWrap recordCraftTable">
                            <el-table
                                :data="tableData"
                                stripe
                                border
                                fit
                                :empty-text="$t('WorkShopDashBoard.noEquipmentTableMessage')"
                                style="width: 95%;margin:10px auto;">
                                <el-table-column
                                    prop="Machine"
                                    :label="$t('RecordCraft.tableTitle1')"
                                    align="center"
                                    width="120">
                                </el-table-column>
                                <el-table-column
                                    prop="Recipe"
                                    :label="$t('RecordCraft.tableTitle2')"
                                    align="center"
                                    width="300">
                                </el-table-column>
                                <el-table-column
                                    prop="Reviser"
                                    :label="$t('RecordCraft.tableTitle3')"
                                    align="center"
                                    width="120"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="DateTime"
                                    :label="$t('RecordCraft.tableTitle4')"
                                    align="center"
                                    width="180">
                                </el-table-column>
                                <el-table-column
                                    prop="Item"
                                    :label="$t('RecordCraft.tableTitle5')"
                                    align="center"
                                    min-width="180">
                                </el-table-column>
                                <el-table-column
                                    prop="Data"
                                    :label="$t('RecordCraft.tableTitle6')"
                                    align="center"
                                    width="300"
                                >
                                </el-table-column>
                            </el-table>
                            <!-- 分页 -->
                            <el-pagination
                                class="pagination"
                                background
                                layout="prev, pager, next"
                                :total="listTotal"
                                :current-page.sync="nowPage"
                                @current-change="handleCurrentChange">
                            </el-pagination>
                        </div>
                    </div>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>
<script>
import leftNav from "@/components/nav.vue"
import { formatDate } from '../assets/js/date.js'
export default {
    name: 'EquipmentEfficiency',
    components: {
        leftNav
    },
    data(){
        return{
            visible1:false,
            visible2:false,
            //设备选项
            machineList:[],
            //设备上次选中项
            selectBeforeMachine:[],
            //设备选中项
            selectmachine:[],
            //设备提交项
            choosedmachine:'',
            all:{label:"全部",value:''},
            //规格选项
            recipeList:[],
            //规格上次选中项
            selectBeforeRecipe:[{label:"全部",value:''}],
            //规格选中项
            selectRecipe:[{label:"全部",value:''}],
            //规格提交项
            choosedRecipe:'',
            allRecipe:{label:"全部",value:''},
            noRecord:0, //1是查询范围内无结果，2是未记录
            loading:false,
            loading2:false,
            loading3:false,
            loading4:false,
            //选中时间
            datePicker:[],
            //选中的时间开始时间与结束时间
            startTimePicker:'',
            endTimePicker:'',
            editable:false,
            //表格数据
            tableData:[],
            // 总数
            listTotal:null,
            // 当前页数
            nowPage: 1,
            //每页条数
            nowPageSize: 10,
            fullscreenLoading:false,
            // 筛选调整人弹出框
            visible3:false,
            // 有无调整人
            nopeople:0,
            //选中的调整人数组
            //上次选中项
            selectBeforePeople:[{label:"全部",value:''}],
            //选中项
            selectPeople:[{label:"全部",value:''}], 
            allPeople:{label:"全部",value:''},
            peopleStr:'',
            //调整人列表
            peopleList:[],
            // 筛选项的基础数据
            options:[],
            props: { multiple: true },
            tagsVal:[],
            // 失焦暂存调整项选择值
            staged:[],
            codeStr:'',
            allCodes:[],
            // 调整项下拉框是否展开
            showTags:false,
            iscascaderShow:0
        }
    },
    computed: {
        islangChange () {
            return this.$store.state.lang
        }
    },
    watch: {
        islangChange (curval, oldval) {
            if (curval != oldval) {
                this.$nextTick(()=>{
                    this.$parent.reload()
                })
            }
        },  
    },
    mounted () {
        if (this.$store.state.reloadState === false) {
            this.$store.state.reloadState = true
            this.$parent.reload()
        }else{
           this.defaultTime()
        }
    },
    methods:{
        //时间筛选默认一周 
        async defaultTime(){
            let nowTime = new Date().getTime()
            let startTime = nowTime-(7*86400000)
            this.datePicker=[formatDate(new Date(startTime) ,'yyyy-MM-dd')+' 00:00:00',formatDate(new Date(nowTime) ,'yyyy-MM-dd')+' 23:59:59']
            this.startTimePicker=formatDate(new Date(startTime) ,'yyyy-MM-dd')+' 00:00:00'
            this.endTimePicker=formatDate(new Date(nowTime) ,'yyyy-MM-dd')+' 23:59:59'
            await this.getmachineList()
            this.getCodeList()
            this.getRecipeList()
            this.getTableInfo()
            this.getPeopleList()
            
        },
        getTableInfoByLook(){
            this.nowPage = 1
            let factoryId = localStorage.getItem('defaultFactoryId')
            localStorage.setItem(factoryId,JSON.stringify(this.selectmachine))
            this.getTableInfo()
        },
        //筛选规格框隐藏后
        hideRecipe(){
            let selectRecipes=this.selectRecipe.map(function(obj){
                return obj.label;
            }).join(",");
            if(selectRecipes!=this.choosedRecipe)this.selectRecipe=this.selectBeforeRecipe
        },
        //筛选机器框隐藏后
        hideMachine(){
            let selectmachines=this.selectmachine.map(function(obj){
                return obj.value;
            }).join(",");
            //若本次选择与选中项(即未确认)不同,恢复到之前选中项
            if(selectmachines!=this.choosedmachine)this.selectmachine=this.selectBeforeMachine
        },
        // 筛选调整人框隐藏后
        hidePeople(){
            this.selectPeople = JSON.parse(JSON.stringify(this.selectBeforePeople))
        },
        //machine判断是否选中
        isActiveMachine(chooseOne){
            for(let j=0;j<this.selectmachine.length;j++){
                if(this.selectmachine[j].value==chooseOne.value && this.selectmachine[j].label==chooseOne.label)return true
            }
        },
        //判断recipe是否选中
        isActiveRecipe(chooseOne){
            for(let j=0;j<this.selectRecipe.length;j++){
                if(this.selectRecipe[j].value==chooseOne.value && this.selectRecipe[j].label==chooseOne.label)return true
            } 
        },
        // 获取机械列表
        async getmachineList(){
            let _this = this
            this.loading4=true
            let data = {
                isHistory: true
            }
            if(this.choosedRecipe !== null &&this.choosedRecipe !== undefined &&this.choosedRecipe !== ''){
                let key5 = "stycleCodes";
                data[key5] = this.choosedRecipe;
            }
            if(this.peopleStr !== null &&this.peopleStr !== undefined &&this.peopleStr !== ''){
                let key = "revisers";
                data[key] = this.peopleStr;
            }
            if(this.codeStr !== null &&this.codeStr !== undefined &&this.codeStr !== ''){
                let key2 = "codes";
                data[key2] = this.codeStr;
            }
            if(this.startTimePicker !== null &&this.startTimePicker !== undefined &&this.startTimePicker !== ''){
                let key4 = "startDate";
                data[key4] = this.startTimePicker;
            }
            if(this.endTimePicker !== null &&this.endTimePicker !== undefined &&this.endTimePicker !== ''){
                let key3 = "endDate";
                data[key3] = this.endTimePicker;
            }
            await this.axios({
                method: 'get',
                url: '/url/parameters/getMachineList',
                params: data
            }).then(function(res){
                if (res.data.success === true){
                    let machineContent=res.data.data
                    _this.machineList=[]
                    for(let i = 0; i < machineContent.length; i++) {
                        let machineInfo={label:machineContent[i].equipmentName+'('+machineContent[i].nameZh+')',value:machineContent[i].id}
                        _this.machineList.push(machineInfo)
                    }
                    let factoryId = localStorage.getItem('defaultFactoryId')
                    if(localStorage.getItem(factoryId)){
                        let selectObj =JSON.parse(localStorage.getItem(factoryId)) 
                        let arr = []
                        selectObj.some(item=>{
                            arr.push(item.value)
                        })
                        _this.choosedmachine= arr.toString()
                        _this.selectmachine=selectObj
                        _this.selectBeforeMachine=selectObj
                    }else{
                        _this.choosedmachine= machineContent[0].id
                        _this.selectmachine=[{label:machineContent[0].equipmentName+'('+machineContent[0].nameZh+')',value:machineContent[0].id}]
                        _this.selectBeforeMachine=[{label:machineContent[0].equipmentName+'('+machineContent[0].nameZh+')',value:machineContent[0].id}]
                    }
                }else{
                    _this.$message.error(res.data.msg);
                }
                 _this.loading4=false
                 return Promise.resolve()
            })  
        },
        // 获取规格列表
        getRecipeList(){
            let _this = this
            this.recipeList=[]
            // this.selectRecipe=[{label:"全部",value:''}]
            // this.choosedRecipe=''
            this.loading=true
            let recipeData={}
            if(this.choosedmachine !== null &&this.choosedmachine !== undefined &&this.choosedmachine !== ''){
                let key5 = "machineIds";
                recipeData[key5] = this.choosedmachine;
            }
            if(this.peopleStr !== null &&this.peopleStr !== undefined &&this.peopleStr !== ''){
                let key = "revisers";
                recipeData[key] = this.peopleStr;
            }
            if(this.codeStr !== null &&this.codeStr !== undefined &&this.codeStr !== ''){
                let key2 = "codes";
                recipeData[key2] = this.codeStr;
            }
            if(this.startTimePicker !== null &&this.startTimePicker !== undefined &&this.startTimePicker !== ''){
                let key4 = "startDate";
                recipeData[key4] = this.startTimePicker;
            }
            if(this.endTimePicker !== null &&this.endTimePicker !== undefined &&this.endTimePicker !== ''){
                let key3 = "endDate";
                recipeData[key3] = this.endTimePicker;
            }
            this.axios({
                method: 'get',
                url: '/url/parameters/getStyleCodeList',
                params: recipeData
            }).then(function(res){
                if (res.data.success === true){
                    // delete res.data.data
                    if('data' in res.data){
                        if(res.data.data.length==0){
                            _this.noRecord=2
                        }else{
                            _this.noRecord=0
                            let recipeContent=res.data.data
                            for(let j = 0; j < recipeContent.length; j++) {
                                let recipeInfo={label:recipeContent[j],value:j+1}
                                _this.recipeList.push(recipeInfo)
                            }
                        }
                        _this.loading=false
                    }else{
                        _this.noRecord=1
                        _this.loading=false
                    }
                }else{
                    _this.loading=false
                    // _this.$message.error(res.data.msg);
                }
            })  
        },
        //点击筛选规格按钮
        checkRecipeBtn(){
            // if (this.datePicker===null || this.datePicker.length === 0) {
            //     this.$message.error(this.$t('EquipmentEfficiency.error1'));
            // }else if(this.selectRecipe.length === 0){
            //     this.$message.error(this.$t('EquipmentEfficiency.error2'));
            // }
        },
        // 获取调整人列表
        getPeopleList(){
            let _this = this
            this.loading2=true
            let data = {}
            
            if(this.choosedmachine !== null &&this.choosedmachine !== undefined &&this.choosedmachine !== ''){
                let key5 = "machineIds";
                data[key5] = this.choosedmachine;
            }
           if(this.choosedRecipe !== null &&this.choosedRecipe !== undefined &&this.choosedRecipe !== ''){
                let key = "stycleCodes";
                data[key] = this.choosedRecipe;
            }
            if(this.codeStr !== null &&this.codeStr !== undefined &&this.codeStr !== ''){
                let key2 = "codes";
                data[key2] = this.codeStr;
            }
            if(this.startTimePicker !== null &&this.startTimePicker !== undefined &&this.startTimePicker !== ''){
                let key4 = "startDate";
                data[key4] = this.startTimePicker;
            }
            if(this.endTimePicker !== null &&this.endTimePicker !== undefined &&this.endTimePicker !== ''){
                let key3 = "endDate";
                data[key3] = this.endTimePicker;
            }
            this.axios({
                method: 'get',
                url: '/url/parameters/getHistoryReviserList',
                params: data
            }).then(function(res){
                if (res.data.success){
                    _this.peopleList=res.data.data
                    if(res.data.data.length==0)_this.nopeople=1
                    else _this.nopeople=0
                }else{
                    _this.$message.error(res.data.msg);
                }
                _this.loading2=false
            })
        },
        // 获取筛选调整项
        getCodeList(){
            let _this = this
            this.loading3=true
            let data = {
                language:this.$store.state.lang
            }
            if(this.choosedmachine !== null &&this.choosedmachine !== undefined &&this.choosedmachine !== ''){
                let key5 = "machineIds";
                data[key5] = this.choosedmachine;
            }
           if(this.choosedRecipe !== null &&this.choosedRecipe !== undefined &&this.choosedRecipe !== ''){
                let key = "stycleCodes";
                data[key] = this.choosedRecipe;
            }
            if(this.peopleStr !== null &&this.peopleStr !== undefined &&this.peopleStr !== ''){
                let key2 = "revisers";
                data[key2] = this.peopleStr;
            }
            if(this.startTimePicker !== null &&this.startTimePicker !== undefined &&this.startTimePicker !== ''){
                let key4 = "startDate";
                data[key4] = this.startTimePicker;
            }
            if(this.endTimePicker !== null &&this.endTimePicker !== undefined &&this.endTimePicker !== ''){
                let key3 = "endDate";
                data[key3] = this.endTimePicker;
            }
            this.axios({
                method: 'get',
                url: '/url/parameters/getHistoryCodeList',
                params: data
            }).then(function(res){
                if (res.data.success){
                    let baseOBJ=[]
                    if(res.data.data.length!==0){
                        baseOBJ = [{
                            label:_this.$t('home.All'),
                            value:0,
                            children:res.data.data
                        }]
                    }
                    _this.options=baseOBJ
                    _this.tagsVal=[]
                    _this.allCodes=[]
                    let condition=_this.options.length !== 0
                    if (condition) _this.screenCodes()
                    else _this.loading3=false
                }else{
                    _this.$message.error(res.data.msg);
                    _this.loading3=false
                }
                
            })
        },
        // 筛选调整项全部默认值
        screenCodes(){
            this.getAllCodes([],this.options)
            if (this.staged.length===0) {
                this.loading3=false
                return
            }
            setTimeout(() => {
                let resArr = []
                for (const item of this.staged) {
                    let include = this.checkrepeat(item)
                    if (include) resArr =[...resArr,item]
                }
                let lastCodeArr=[]
                for (const iterator of resArr) {
                    let val = iterator[iterator.length-1]
                    lastCodeArr.push(val)
                }
                this.codeStr = lastCodeArr.toString()
                this.tagsVal=[...resArr]
                this.loading3=false
            }, 500);
        },
        checkrepeat(i){
            let b = i.toString()
            for (const item of this.allCodes) {
                let a = item.toString() 
                if (a===b)return true
            }

            
        },
        getAllCodes(upArr,data){
            for (const item of data) {
                let allArr=[...upArr,item.value]
                if(item.children){
                    this.getAllCodes(allArr,item.children)
                }else{
                    this.allCodes.push(allArr)
                }
            }
        },
        // 失焦时 保存选中的调整项。 用于对联动返回的结果进行筛选，取出相同的值（这就是联动的默认值），并返显到组件中
        async stagedFun(type){
           
            // 选择框收起&数据改变的时候调用
            if (typeof(type)=='boolean') this.showTags = type
            if(this.showTags) return
            this.staged=[...this.tagsVal]
            let lastCodeArr=[]
            for (const iterator of this.tagsVal) {
                let val = iterator[iterator.length-1]
                lastCodeArr.push(val)
            }
            this.codeStr = lastCodeArr.toString()
            await this.getmachineList()
            this.getRecipeList()
            this.getPeopleList()
            ++this.iscascaderShow
        },
        //点击设备
        selectmachineId(item){
            let all = this.selectmachine.some(i=>{
                if(i.label=='全部'||i.label=='All')return true
            })
            let flag = this.selectmachine.some(i=>{
                if(i.value==item.value)return true
            })
            if(flag===true){
                //不直接删除原数组中的项
                let selectmachineList=this.selectmachine.concat([])
                let index = selectmachineList.findIndex((el) => {
                    return el.value === item.value
                })
                selectmachineList.splice(index, 1)
                this.selectmachine=selectmachineList
                //splice()会改变原本的数组，与push()相似，造成之前选中项随之改变
                // this.selectmachine.splice(selectmachineList.indexOf(item), 1)
                if(this.selectmachine.length===0)this.selectmachine.push(this.all)
                return
            }
            if(item.value===''){
                this.selectmachine=[]
                //concat将两个数组合成一个新的,在进行赋值,selectmachine得到一个新的地址存的新值
                let arr = this.selectmachine.concat([item])
                this.selectmachine =arr
                //采用push的方法会直接改变原数组,会污染原数组
                // this.selectmachine.push(item)
            }else if(all===true){
                this.selectmachine=[]
                let arr = this.selectmachine.concat([item])
                this.selectmachine =arr
                // this.selectmachine.push(item)
            }else{
                let arr = this.selectmachine.concat([item])
                this.selectmachine =arr
                this.selectmachine.sort(this.compare("value"))
                // this.selectmachine=this.selectmachine.push(item)
            }
        },
        //按属性数字大小给对象数组排序
        compare(property) {
            return function (a, b) {
                var value1 = a[property];
                var value2 = b[property];
                return value1 - value2;
            }
        },
        //选择设备点击确认
        clickmachine(){
            this.selectBeforeMachine= this.selectmachine
            this.choosedmachine = this.selectmachine.map(function(obj){
                return obj.value;
            }).join(",");
            if(this.datePicker!=null){
                this.getPeopleList()
                this.getCodeList()
                this.getRecipeList()
            }
            this.$refs.popover1.doClose()
        },
        //点击规格
        selectRecipeId(item){
            let allRecipe = this.selectRecipe.some(i=>{
                if(i.label=='全部'||i.label=='All')return true
            })
            let flagRecipe = this.selectRecipe.some(i=>{
                if(i.value==item.value)return true
            })
            if(flagRecipe===true){
                let selectRecipeList=this.selectRecipe.concat([])
                let index = selectRecipeList.findIndex((el) => {
                    return el.value === item.value
                })
                selectRecipeList.splice(index, 1)
                this.selectRecipe=selectRecipeList
                // this.selectRecipe.splice(this.selectRecipe.indexOf(item), 1)
                if(this.selectRecipe.length===0)this.selectRecipe.push(this.allRecipe)
                return
            }
            if(item.value===''){
                this.selectRecipe=[]
                let arr = this.selectRecipe.concat([item])
                this.selectRecipe =arr
                // this.selectRecipe.push(item)
            }else if(allRecipe===true){
                this.selectRecipe=[]
                let arr = this.selectRecipe.concat([item])
                this.selectRecipe =arr
                // this.selectRecipe.push(item)
            }else{
                let arr = this.selectRecipe.concat([item])
                this.selectRecipe =arr
                this.selectRecipe.sort(this.compare("value"))
                // this.selectRecipe.push(item)
            }
        },
        //选择设备点击确认
        async clickrecipe(){
            this.selectBeforeRecipe=this.selectRecipe
            if (this.selectRecipe[0].value==''){
                this.choosedRecipe=''
            }else{
                this.choosedRecipe=this.selectRecipe.map(function(obj){
                    return obj.label;
                }).join(",");
            }
            await this.getmachineList()
            this.getCodeList()
            this.getPeopleList()
            this.$refs.popover2.doClose()
        },
         // 点击调整人
        clickPeople(item){
            // 判断是否点的全部
            if(item.label){
                this.selectPeople=[item]
                return
            }
            // 判断是否点击的选中的按钮（如选中则取消）
            if (this.selectPeople.includes(item)){
                 let index = this.selectPeople.findIndex((el) => {
                    return el.value === item.value
                })
                this.selectPeople.splice(index, 1)
                if(this.selectPeople.length===0) this.selectPeople=[this.allPeople]
                return
            }
            // 选中
            let first = this.selectPeople[0]
            if (typeof(first) === 'object'){
                this.selectPeople=[]
            }
            this.selectPeople=[...this.selectPeople,item]
        },
        // 确认筛选人
        async confirmPeople(){
            this.selectBeforePeople = JSON.parse(JSON.stringify(this.selectPeople))
            let first = this.selectPeople[0]
            if (typeof(first) === 'object'){
                this.peopleStr=''
            }else{
                this.peopleStr = this.selectPeople.toString()  
            }
            await this.getmachineList()
            this.getCodeList()
            this.getRecipeList()
            this.$refs.popover3.doClose()
        },
        // 切换计算周期的时间
        async changeTime(){
            if (this.datePicker === null) {
                this.startTimePicker=''
                this.endTimePicker=''
                await this.getmachineList()
                this.getRecipeList()
                this.getCodeList()
                this.getPeopleList()
            }else if(this.datePicker!=null){
                this.startTimePicker=this.datePicker[0]+' 00:00:00'
                this.endTimePicker=this.datePicker[1]+' 23:59:59'
                await this.getmachineList()
                this.getRecipeList()
                this.getCodeList()
                this.getPeopleList()
            }
        },
        // 分页
        handleCurrentChange (val) {
            this.nowPage = val
            //获取表格数据
            this.getTableInfo()
        },
        // 获取表格信息
        getTableInfo(){
            let _this = this
            this.fullscreenLoading=true
            let data={
                        pageNum: this.nowPage,
                        pageSize: this.nowPageSize,
                        language: this.$store.state.lang
                    }
            if(this.datePicker!=null){
                if(this.datePicker.length!=0){
                    let key1 = "startDate";
                    data[key1] = this.startTimePicker;
                    let key2 = "endDate";
                    data[key2] = this.endTimePicker;
                }
            }
            if(this.peopleStr !== null &&this.peopleStr !== undefined &&this.peopleStr !== ''){
                let key = "revisers";
                data[key] = this.peopleStr;
            }
            if(this.codeStr !== null &&this.codeStr !== undefined &&this.codeStr !== ''){
                let key2 = "codes";
                data[key2] = this.codeStr;
            }
            if(this.choosedmachine !== null &&this.choosedmachine !== undefined &&this.choosedmachine !== ''){
                let key3 = "machineIds";
                data[key3] = this.choosedmachine;
            }
            if(this.choosedRecipe !== null &&this.choosedRecipe !== undefined &&this.choosedRecipe !== '' &&this.choosedRecipe !== '全部'){
                let key4 = "recipes";
                data[key4] = this.choosedRecipe;
            }
            this.axios({
                method: 'post',
                url: '/url/parameters/getHistoryListData',
                params:data
            }).then(function(res){
                if (res.data.success == 'true'){
                    let tableDatas=res.data.data
                    tableDatas.forEach(element => {
                        element.DateTime=formatDate(new Date(element.DateTime), 'yyyy-MM-dd hh:mm:ss')
                    });
                    _this.listTotal=res.data.total
                    _this.tableData=res.data.data
                    _this.fullscreenLoading=false
                }else{
                    _this.$message.error(res.data.msg);
                    _this.fullscreenLoading=false
                }
            })  
        },
        //导出
        exportExcel(){
            let signTime = new Date().getTime()
            this.$store.commit('nowsign', signTime)
            let urlData = '?language='+ this.$store.state.lang + '&sign='+this.$store.state.sign + '&auth_Code='+this.$store.state.authCode+'&sign_time='+signTime +'&route='+this.$store.state.newroute+'&factory_id='+this.$store.state.factoryId
            if(this.datePicker!=null){
                if(this.datePicker.length!=0){
                    let dateString= '&startDate='+ this.startTimePicker + '&endDate='+this.endTimePicker 
                    urlData=urlData+dateString
                }
            }
             if(this.peopleStr !== null &&this.peopleStr !== undefined &&this.peopleStr !== ''){
                let reviserStr = "&revisers="+this.peopleStr;
                urlData=urlData+reviserStr
            }
            if(this.codeStr !== null &&this.codeStr !== undefined &&this.codeStr !== ''){
                let codeStr = "&codes="+this.codeStr
                urlData=urlData+codeStr
            }
            if(this.choosedmachine !== null &&this.choosedmachine !== undefined &&this.choosedmachine !== ''){
                let machineIdString = '&machineIds='+ this.choosedmachine
                urlData=urlData+machineIdString
            }
            if(this.choosedRecipe !== null &&this.choosedRecipe !== undefined &&this.choosedRecipe !== '' &&this.choosedRecipe !== '全部'){
                let recipeString = '&recipes='+ this.choosedRecipe
                urlData=urlData+recipeString
            }
            window.open('/url/parameters/excelHistoryListData' + urlData, '_blank')
        }
    }
}
</script>
<style scoped>
/deep/ .itemWrap .el-icon-close{
    display: none;
}
.CompareCraft{
  min-width: 1000px!important;
  display: flex;
}
.mainWrao{
  min-width: 100%;
  background-color: #f6f9fc;
  box-shadow: 0px 5px 13px 0px rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
  border-radius: 4px;
  padding-bottom: 10px;
}
.recordTitle{
  padding: 20px 25px;
  background-color: #fff;
  border-bottom: 1px solid #e5e5e5;
  border-radius: 4px 4px 0 0;
  line-height: 35px;
  /* overflow: auto; */
}
.recordTitle h1{
  font-size: 20px;
  color: #525f7f;
  margin-bottom: 5px;
}
.tableWrap{
  box-sizing: border-box;
  margin: 10px 15px;
}
.chooseButton{
  margin-top: 10px;
  /* float: right; */
  display: flex;
  justify-content: space-between;
}
.noMachine{
  text-align: center;
  line-height: 70px;
  color: #909399;
}
.machineList{
  display: flex;
  flex-wrap: wrap;
}
.machineList li{
  width: 150px;
  margin: 0 5px;
  text-align: center;
  height: 24px;
  line-height: 24px;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.25);
  border:1px solid #ccc;
  border-radius: 5px;
  margin-bottom: 10px;
  font-size: 13px;
  cursor: pointer;
  overflow:hidden;
  padding:0 10px;
  white-space: nowrap;
  text-overflow: ellipsis;
  box-sizing:border-box;
}
.machineList.recipeList li{
  width: 95%;
  text-align: left;
}
.active{
  color:#fff;
  background: #66b1ff;
}
.export {
  /* float: right; */
  width: 100px;
}
.pagination{
  text-align: center;
  margin-top: 35px;
}
.dateSelect{
    width: 250px!important;
}
</style>
